import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

/** 带背景logo图标css变量基类 */
export abstract class _LogoHasBackgroundBase extends BaseCssVarValue {
  abstract cssType: 'default'
  /** logo图标的背景宽度 */
  ['--logo-has-background-width']?: string;
  /** logo图标的背景高度 */
  ['--logo-has-background-height']?: string;
  /** logo图标背景的颜色 */
  ['--logo-has-background-color']?: string;
  /** logo图标的宽度 */
  ['--logo-icon-width']?: string;
  /** logo图标的高度 */
  ['--logo-icon-height']?: string
}
